

$('.partner-login a').click(function () {
    $('#user_login').attr('placeholder', 'Username');
    $('#user_pass').attr('placeholder', 'Password');
    $('#modal-login').modal('show');
});

$(document).ready(function () {
    $('#wp-submit').click(function (e) {
        var isValid = true;

        if ($('#user_login').val() == '') {
            isValid = false;
            $('#user_login').css('border-color', 'red');
        }
        else {
            isValid = true;
            $('#user_login').css('border-color', '');
        }

        if ($('#user_pass').val() == '') {
            isValid = false;
            $('#user_pass').css('border-color', 'red');
        }
        else {
            isValid = true;
            $('#user_pass').css('border-color', '');
        }

        if (isValid == false) {
            $('.validation-error').css('display', 'inherit');
            e.preventDefault();
        }
        else {
            $('.validation-error').css('display', 'none');
        }

    });
});


